import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    MarkUnhelpfulAndDeleteTask as MarkUnhelpfulAndDeleteTaskMutation,
    MarkUnhelpfulAndDeleteTaskVariables,
    TaskMarkUnhelpfulAndDeleteInput,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../../../apollo-client';
import CORE_ENTITY_TASK_FRAGMENT from '../../../../graphql/fragments/core-entity-task-fragment.graphql';

import {removeTaskFromCaches} from '../helpers/remove-task-from-caches';
import MARK_UNHELPFUL_AND_DELETE_TASK from '../mutations/mark-unhelpful-and-delete-task.graphql';

export const useMarkUnhelpfulAndDeleteTask = (): {
    markUnhelpfulAndDeleteTask: (input: TaskMarkUnhelpfulAndDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [markUnhelpfulAndDeleteTask, {loading, error}] = useMutation<
        MarkUnhelpfulAndDeleteTaskMutation,
        MarkUnhelpfulAndDeleteTaskVariables
    >(MARK_UNHELPFUL_AND_DELETE_TASK);

    return {
        markUnhelpfulAndDeleteTask: (input: TaskMarkUnhelpfulAndDeleteInput) => {
            const cachedTask = nutApolloClient.readFragment({
                id: input.task,
                fragmentName: 'CoreEntityTaskFragment',
                fragment: CORE_ENTITY_TASK_FRAGMENT,
            });

            return markUnhelpfulAndDeleteTask({
                variables: {input},
                optimisticResponse: cachedTask
                    ? {
                          taskMarkUnhelpfulAndDelete: {
                              __typename: 'TaskMarkUnhelpfulAndDeletePayload',
                              task: cachedTask,
                          },
                      }
                    : undefined,
                update: (proxy) =>
                    cachedTask && removeTaskFromCaches(proxy, input.task, cachedTask),
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
